import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from 'flarum/common/components/LinkButton';
import UserPageResolver from 'flarum/forum/resolvers/UserPageResolver';
import ClaimPage from './components/ClaimPage';
import ResultPage from './components/ResultPage';
import UserResultsPage from './components/UserResultsPage';
import setUpTracking from './tracking';

// Results from okjapa.com: /assessments/claim?code=... (sign up or log in, then the answers attach to the account),
// /assessments/results/{id} (one result) and "My results" on the member's own profile.
app.initializers.add('voucha-assessments', () => {
  // Ad measurement: consent banner, Meta Pixel, Google tag, "created account" event (see tracking.js)
  setUpTracking();
  app.routes['voucha-assessments.claim'] = {
    path: '/assessments/claim',
    component: ClaimPage
  };
  app.routes['voucha-assessments.result'] = {
    path: '/assessments/results/:id',
    component: ResultPage
  };
  app.routes['voucha-assessments.mine'] = {
    path: '/u/:username/results',
    component: UserResultsPage,
    resolverClass: UserPageResolver
  };

  // "My results" in the profile menu, for the member's own profile only
  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user;
    if (!user || !app.session.user || app.session.user.id() !== user.id()) return;
    items.add('voucha-results', m(LinkButton, {
      href: app.route('voucha-assessments.mine', {
        username: user.slug()
      }),
      icon: "fas fa-compass"
    }, "My results"), 60);
  });
});